<template>
  <div class="alert-box btn-multi-block btn-multi-expand-block">
    <div class="alert-box__header btn-multi btn-multi-expand--active">
      {{ title }}
    </div>
    <div class="alert-box__contents">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.alert-box {
  padding: 24px;

  &__header {
    padding: 0;
    height: auto;
    margin-bottom: 8px;
    font-size: 12px;
    text-align: center;
    font-weight: bold;
    line-height: 1.6;
    color: $danger;
    cursor: default;

    &:hover {
      opacity: 1;
    }
  }

  &__contents {
    padding: 0;
  }
}
</style>
